import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#b39ddb', '#7986cb'];
const RADIAN = Math.PI / 180;

function ChileansNoChileansEmployees({ title = {} }) {
  const chileansEmployees = title.Chilena ?? 0;
  const noChileansEmployees = Object.entries(title)
    .filter(([key]) => key !== 'Chilena')
    .reduce((acc, [, count]) => acc + count, 0);

  const data = [
    { name: 'Chilenos', value: chileansEmployees },
    { name: 'Extranjeros', value: noChileansEmployees }
  ];

  const renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, percent }) => {
    const radius = outerRadius + 5; // Más lejos del borde del gráfico
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="#222" fontSize={10} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div style={{ width: '100%', height: 115, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ flex: 1 }}>
        <ResponsiveContainer width="100%" height="80%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={30}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
      {/* Leyenda en la parte inferior */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
        {data.map((entry, index) => (
          <div key={entry.name} style={{ display: 'flex', alignItems: 'center', marginRight: 16 }}>
            <span
              style={{
                display: 'inline-block',
                width: 12,
                height: 12,
                backgroundColor: COLORS[index % COLORS.length],
                borderRadius: '50%',
                marginRight: 6
              }}
            />
            <span style={{ fontSize: 12, color: '#757575' }}>{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChileansNoChileansEmployees;
